import Vue from "vue"
import Vuex from "vuex"
import snackbar from "./modulos/snackbar";
import fornecedor from "./modulos/fornecedor";
import usuario from "./modulos/usuario";
import loading from "./modulos/loading";
import tabela from "./modulos/tabela_dashboard";
import chart_fornecedor from "./modulos/chart_fornecedor";
import tabela_compra from "./modulos/tabela_compra";
import detalhe_produto from "./modulos/detalhe_produto";
import candidato_ativo from "./modulos/candidato_ativo";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  modules: {
    snackbar,
    fornecedor,
    usuario,
    loading,
    tabela,
    chart_fornecedor,
    tabela_compra,
    detalhe_produto,
    candidato_ativo
  }
});
